import React from 'react';
import Columns from 'react-bulma-components/lib/components/columns';

import './style.scss';

export const Row = ({
  children,
  hasBottomBorder = false,
  paddingLeft = false,
  paddingRight = false,
  bordered = false,
  ...props
}) => (
  <div
    className={`row-wrap${bordered ? ' bordered' : ''}${
      paddingLeft ? ' pad-left' : ''
    }${paddingRight ? ' pad-right' : ''}${
      hasBottomBorder ? ' has-bottom-border' : ''
    }`}
  >
    <Columns {...props}>{children}</Columns>
  </div>
);

export default Row;
